<div class="main-login">  
    <div class="container">
        <div class="left-section">
        <img src="/assets/logo_2x.png" alt="Conectio Logo" class="logo">
        <h2>{{ 'login.title' | translate }} <span class="highlight">Conectio</span></h2>
        <p>{{ 'login.subtitle' | translate }}</p>
        <p>{{ 'login.description' | translate }}</p>
        <h3>{{ 'login.advantages.title' | translate }}</h3>
        <ul>
            <li>{{ 'login.advantages.career' | translate }}</li>
            <li>{{ 'login.advantages.match' | translate }}</li>
            <li>{{ 'login.advantages.opportunities' | translate }}</li>
            <li>{{ 'login.advantages.support' | translate }}</li>
            <li>{{ 'login.advantages.personal' | translate }}</li>
        </ul>
        </div>
        <div class="right-section">
        <h2>{{ 'login.form.title' | translate }}</h2>
        <form [formGroup]="loginForm">
            <mat-form-field appearance="fill" [ngClass]="{'invalid-field': (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) || errorEmail}">
                <input matInput type="text" id="email" formControlName="email" [placeholder]="'login.form.email' | translate" required>
            </mat-form-field>

            <mat-form-field appearance="fill" [ngClass]="{'invalid-field': loginForm.get('password')?.invalid && loginForm.get('password')?.touched}">
                <input matInput type="password" id="password" formControlName="password" [placeholder]="'login.form.password' | translate" required>
            </mat-form-field>


        </form>
        <div class="buttons-section">
            <button mat-raised-button color="primary"  class="light-button" (click)="login('manual')">
                {{ 'login.form.loginButton' | translate }}
            </button>
            <div class = "o-text" style="margin-bottom: 0px; margin-top:15px">{{ 'login.form.or' | translate }}</div>

            <button mat-raised-button color="primary" style="margin-top: 20px;" class = "linkedin-button" (click)="login('linkedin')">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.5 0.65625H1.5C1.10218 0.65625 0.720644 0.814285 0.43934 1.09559C0.158035 1.37689 0 1.75843 0 2.15625V19.1562C0 19.5541 0.158035 19.9356 0.43934 20.2169C0.720644 20.4982 1.10218 20.6562 1.5 20.6562H18.5C18.8978 20.6562 19.2794 20.4982 19.5607 20.2169C19.842 19.9356 20 19.5541 20 19.1562V2.15625C20 1.75843 19.842 1.37689 19.5607 1.09559C19.2794 0.814285 18.8978 0.65625 18.5 0.65625ZM6 17.6562H3V8.65625H6V17.6562ZM4.5 6.90625C4.15618 6.89642 3.82288 6.78549 3.54175 6.58733C3.26062 6.38916 3.04411 6.11254 2.9193 5.79203C2.79448 5.47152 2.76687 5.12133 2.83994 4.78522C2.913 4.44911 3.0835 4.14199 3.33011 3.90222C3.57673 3.66246 3.88853 3.50068 4.22656 3.43711C4.5646 3.37354 4.91387 3.411 5.23074 3.54479C5.5476 3.67859 5.81802 3.9028 6.00819 4.1894C6.19836 4.476 6.29986 4.81229 6.3 5.15625C6.2921 5.6266 6.09834 6.0747 5.76105 6.40262C5.42376 6.73053 4.97039 6.9116 4.5 6.90625ZM17 17.6562H14V12.9163C14 11.4963 13.4 10.9862 12.62 10.9862C12.3913 11.0015 12.1679 11.0617 11.9625 11.1636C11.7572 11.2654 11.574 11.4068 11.4235 11.5796C11.273 11.7524 11.1581 11.9533 11.0854 12.1707C11.0127 12.388 10.9837 12.6176 11 12.8462C10.995 12.8928 10.995 12.9397 11 12.9862V17.6562H8V8.65625H10.9V9.95625C11.1925 9.51125 11.5944 9.14882 12.0672 8.90369C12.54 8.65855 13.0677 8.53892 13.6 8.55625C15.15 8.55625 16.96 9.41625 16.96 12.2163L17 17.6562Z" fill="white"/>
                </svg>
                    {{ 'login.form.linkedinButton' | translate }}
                </button>

            <div class="formError" *ngIf="errorEmail"> {{ 'login.errors.invalidCredentials' | translate }} </div>
            <div class="formError" *ngIf="errorEmailConfirmation"> {{ 'login.errors.emailNotConfirmed' | translate }} </div>

        </div>
        </div>
    </div>
</div>